import React from 'react';

import cx from 'classnames';

import styles from './buttonLoader.module.scss';

interface ButtonLoaderProps {
  active: boolean;
  className: string;
}

const ButtonLoader: React.FC<ButtonLoaderProps> = ({ active, className }) => (
  <span className={cx(styles.loader, className, { [styles.blackLoader]: active })}></span>
);

export default ButtonLoader;
